export const AlgoliaSearchAttempt = 'AlgoliaSearchAttempt'
export const AlgoliaSearchFail = 'AlgoliaSearchFail'
export const AlgoliaSearchSuccess = 'AlgoliaSearchSuccess'
export const GetAlgoliaKeyAttempt = 'GetAlgoliaKeyAttempt'
export const GetAlgoliaKeyFail = 'GetAlgoliaKeyFail'
